import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { faBook, faEye, faPlus, faSearch, faUndo } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { SidenavActions, SideNavService } from '../services/side-nav.service';
import { Group } from 'backend/interfaces/group.interface';
import { GroupService } from '../services/group.service';


@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {

  loading = false;
  faHome = faEye;
  faSearch = faSearch;
  faUndo = faUndo;
  displayLimit = 10;
  page = 0;
  faBook = faBook;
  sideNavActions = SidenavActions;
  @ViewChild('groupsPaginator') groupsPaginator: MatPaginator;
  groups: Group[] = [];
  dataSource: MatTableDataSource<Group>;
  pageEvent: PageEvent;
  groupsCount;
  faPlus = faPlus;
  displayedColumns: string[] = [
    'Name',
    'Description',
    'Followers',
    'Businesses',
    'Actions'
  ];
  constructor(public groupService: GroupService, private router: Router, public sidenav: SideNavService) { 
  }
  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.groupService.groupCount$.subscribe(res => {
      this.groupsCount = res;
    })

    this.groupService.groups$.subscribe(res => {
      this.groups = res;
      this.dataSource = new MatTableDataSource(this.groups);
    })
    this.loading = false;
  }

  openGroup(group: Group){
    this.groupService.getGroupById(group.id);
    this.router.navigate(['admin', 'category', group.id]);
  }

  createGroup(): void {
    this.router.navigate(['admin', 'category']);
  }

  async pageGroups(e?: PageEvent): Promise<void>{
    this.loading = true;
    if(e){
      this.displayLimit = e.pageSize;
      this.page = e.pageIndex;
    }
    await this.groupService.getGroups(this.displayLimit, this.page);
    this.loading = false;
  }

  openSideNav(action: SidenavActions): void {
    this.sidenav.open(action);
  }

  reloadGroups(){
    this.groupService.getGroups(10, 0);
  }

  async getGroupBusinessCount(): Promise<void>{
    await this.groups.forEach((g, index) => {
      this.groupService.getGroupBusinessCount(g.id).then(res => {
        this.groups[index].businessess = res;
      })
    })
    this.dataSource = new MatTableDataSource(this.groups);
  }

}
